import { sendGAEvent } from "./utils/googleAnalytics";

export const webNotesLoaded = () => {
  sendGAEvent("webNotes", "webNotesLoaded");
};
